import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db, auth } from './firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import { rolesOf, isAdminOrOwner } from './roles';

// Allows access to users whose Firestore profile has 'admin' OR 'owner' in roles.
// Mirrors the pattern OwnerRoute already uses, just with a wider allow-list.
const AdminOrOwnerRoute = ({ children }) => {
  const [authUser, authLoading] = useAuthState(auth);
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const checkRole = async () => {
      if (!authUser) {
        setChecking(false);
        return;
      }
      try {
        const snap = await getDoc(doc(db, 'users', authUser.uid));
        // rolesOf also honours the legacy single `role` string, which
        // OwnerRoute already accepted — reading it only one of two ways here
        // meant the same profile could pass one guard and fail the other.
        setAllowed(isAdminOrOwner(rolesOf(snap.exists() ? snap.data() : null)));
      } catch (error) {
        console.error('Error checking admin/owner access:', error);
        setAllowed(false);
      } finally {
        setChecking(false);
      }
    };
    if (!authLoading) checkRole();
  }, [authUser, authLoading]);

  if (authLoading || checking) {
    return (
      <div className="w-full flex justify-center items-center h-screen text-gray-500">
        Checking access...
      </div>
    );
  }

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminOrOwnerRoute;
